import { PublicCalendarIcsFeedLinkType } from 'api/types';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/features/utils';
import * as actions from '../actions';

const stateFactory = stateFactories.createInitialMultipleFeatureStateFactory<PublicCalendarIcsFeedLinkType>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const publicCalendarIcsFeedLinkReducer = createReducer<State, Actions>(initialState, {
  [actions.getPublicCalendarIcsFeedLink.request.type]: actionsHandlers.handleMultipleFeatureRequest,
  [actions.getPublicCalendarIcsFeedLink.success.type]: actionsHandlers.handleMultipleFeatureSuccess,
  [actions.getPublicCalendarIcsFeedLink.failure.type]: actionsHandlers.handleMultipleFeatureFailure,
  [actions.getPublicCalendarIcsFeedLink.reset.type]: actionsHandlers.handleMultipleFeatureReset,
});

export default publicCalendarIcsFeedLinkReducer;
